import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill="currentColor">
      <path d="M24.571 15.22l-5.25 1.968a.715.715 0 00-.464.67 5.721 5.721 0 01-5.714 5.713 5.721 5.721 0 01-5.714-5.714 5.721 5.721 0 015.714-5.714H24.57v3.076zm.715-4.506H13.143C9.205 10.714 6 13.92 6 17.857 6 21.796 9.205 25 13.143 25c3.77 0 6.867-2.936 7.125-6.641l5.269-1.976a.714.714 0 00.463-.669V11.43a.714.714 0 00-.714-.715zM12.429 8.571V5.714a.714.714 0 111.428 0v2.857a.714.714 0 11-1.428 0M15.604 9.166a.714.714 0 01-.198-.99l1.428-2.144a.713.713 0 111.189.793l-1.429 2.143a.714.714 0 01-.99.198M8.263 6.825a.714.714 0 111.188-.793l1.429 2.143a.714.714 0 11-1.189.793L8.263 6.825z" />
      <path d="M15.286 17.857A2.145 2.145 0 0113.143 20 2.145 2.145 0 0111 17.857c0-1.181.961-2.143 2.143-2.143s2.143.962 2.143 2.143m-5.715 0a3.575 3.575 0 003.572 3.572 3.575 3.575 0 003.571-3.572 3.575 3.575 0 00-3.571-3.571 3.575 3.575 0 00-3.572 3.571" />
    </g>
  </svg>
);

const IconFoulsCommitted = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconFoulsCommitted;
